import type { ReactNode } from 'react';

export const symbol_music_video: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M494-316.5q26-26.5 26-63.5v-218h71.75q15.25 0 25.75-10.29t10.5-25.5q0-15.21-10.32-25.71-10.33-10.5-25.59-10.5h-71.83q-15.26 0-25.76 10.35Q484-649.3 484-634v180q-10-7-25.5-11.5T430-470q-37.8 0-63.9 26.5T340-380q0 37 26.14 63.5t64 26.5Q468-290 494-316.5ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
